import React from 'react'
import CourseAccordion from './CoursesAccordion';

const Coursedescription = () => {
  return (
    <div>
<CourseAccordion/>
    </div>
  )
}

export default Coursedescription;
